import React from 'react';
import { Currency } from 'ui-toolkit';
import { currencyFields, eFeePropertyNames } from '../../../../types/order/fees/eFeePropertyNames';
import { ILineItem } from '../ILineItem';
import { NameColumn } from './NameColumn';
import { PayeeColumn } from './PayeeColumn';
import classNames from 'classnames';
import { StatusColumn } from './status/StatusColumn';
import { OptionalLinkTW } from 'tailwindComponents/link/OptionalLinkTW';
import { NettedOut } from './NettedOut';

export interface IFeeSectionTableColumnProps {
  columnValue: any;
  columnName: string;
  columnVisible?: boolean;
  editUrl?: string;
  fee?: ILineItem;
  sectionDefinitionId?: string;
}

const feesWithNoNegativeNumbers = ['Cash to Buyer', 'Cash to Seller', 'Cash to Borrower'];

const calcCurrencyValue = (value: any, fee?: ILineItem) => {
  const name = fee?.stringSettlementStatementPropertyValues[eFeePropertyNames.Name];
  if (feesWithNoNegativeNumbers.indexOf(name ?? '') > -1) {
    return value < 0 ? 0 : value;
  }

  return value;
};

export const FeeSectionTableColumn: React.FC<IFeeSectionTableColumnProps> = ({
  columnValue,
  columnName,
  columnVisible,
  editUrl,
  fee,
  sectionDefinitionId,
}) => {
  if (columnVisible === false) {
    return <div></div>;
  }

  const isCurrency = currencyFields.includes(columnName as eFeePropertyNames);
  const isBoolean = columnName === eFeePropertyNames.NettedOut;
  const justification = isCurrency ? 'justify-self-end' : isBoolean ? 'justify-self-center' : 'justify-self-start';
  const isNameColumn = columnName === eFeePropertyNames.Name;
  const isPayeeColumn = columnName === eFeePropertyNames.Payee;
  const isStatusColumn = columnName === eFeePropertyNames.Status;
  const isNotSpecialColumn = !isCurrency && !isBoolean && !isNameColumn && !isPayeeColumn && !isStatusColumn;
  const isDoesNotOpenEdit = isStatusColumn || isBoolean || isPayeeColumn;

  return (
    <>
      {isNameColumn && <NameColumn editUrl={editUrl} columnValue={columnValue} fee={fee} />}
      {!isNameColumn && (
        <OptionalLinkTW
          to={isDoesNotOpenEdit ? undefined : editUrl}
          className={classNames(`self-start p-4 text-base`, justification)}
        >
          {isStatusColumn && <StatusColumn fee={fee} />}
          {isPayeeColumn && <PayeeColumn columnValue={columnValue} fee={fee} />}
          {isCurrency && columnValue !== undefined && <Currency value={calcCurrencyValue(columnValue, fee)} />}
          {isCurrency && columnValue === undefined && '--'}
          {isBoolean && (
            <NettedOut sectionDefinitionId={sectionDefinitionId} columnValue={columnValue} lineItemId={fee?.id} />
          )}
          {isNotSpecialColumn && (columnValue || '--')}
        </OptionalLinkTW>
      )}
    </>
  );
};
